export default {
  init() {
    // JavaScript to be fired on the home page
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
    /* Used Search form */
    const usedFormSubmit   = jQuery('.used-search button[type="submit"]');

    usedFormSubmit.each(function() {
      jQuery(this).on('click', function(e) {
        /* Stop Form from submiting */
        e.preventDefault();

        var form              = jQuery(this).closest('form.used-search');
        var formCondInput     = jQuery(form).find('select.condition');
        var formCatInput      = jQuery(form).find('select.category');
        var formCondError     = jQuery(form).find('.used-search__notification[data-error-target="search-condition"]');
        var formCatError      = jQuery(form).find('.used-search__notification[data-error-target="search-category"]');

        var isValid = true;

        /* Validate condition field */
        if (!formCondInput.val()) {
          formCondError.removeClass('hidden');
          isValid = false;
        }

        /* Validate category field */
        if (!formCatInput.val()) {
          formCatError.removeClass('hidden');
          isValid = false;
        }

        /* Submit the form only if both condition and category are selected */
        if (isValid) {
          /* Get the value from the category select (values are the taxonomy slug) and add appended it to the used machinery slug */
          let formAction = '/machinery/' + formCatInput.val() + '/';

          /* Set the form action */
          form.attr('action', formAction);

          form.submit();
        }

        /* Hide error message when condition is selected */
        formCondInput.on('change', function() {
          if (jQuery(this).val() !== '' && !formCondError.hasClass('hidden')) {
            formCondError.addClass('hidden');
          }
        });

        /* Hide error message when category is selected */
        formCatInput.on('change', function() {
          if (jQuery(this).val() !== '' && !formCatError.hasClass('hidden')) {
            formCatError.addClass('hidden');
          }
        });
      });
    });

    /* Homepage used search form */
    const usedSearchToggle = jQuery('.used-search__toggle');

    usedSearchToggle.on('click', function() {
      jQuery(this).next().slideToggle(300);
    });

    /* Used Search Category and Brand Filter */
    (function () {
      const conditionSelect = document.querySelector('[data-used-search-condition]');
      const categorySelect = document.querySelector('[data-used-search-category]');
      const brandSelect = document.querySelector('[data-used-search-brand]');

      if (!conditionSelect || !categorySelect || !brandSelect) return;

      // Store original options for reset
      const brandOptions = Array.from(brandSelect.options);
      const categoryOptions = Array.from(categorySelect.options);

      // Keep track of selected values
      let lastSelectedCategory = '';
      let lastSelectedBrand = '';

      // Initialize: disable input_2 and input_3 on page load
      categorySelect.disabled = true;
      brandSelect.disabled = true;

      function enableNextField(fieldToEnable) {
        fieldToEnable.disabled = false;
      }

      function disableAndResetField(fieldToDisable) {
        fieldToDisable.disabled = true;
        fieldToDisable.value = '';
      }

      function handleConditionChange() {
        const selectedCondition = conditionSelect.value;

        if (selectedCondition) {
          // Enable input_2 (category) when input_1 (condition) has a value
          enableNextField(categorySelect);

          // Filter categories based on selected condition
          filterCategoriesByCondition(selectedCondition);
        } else {
          // Disable and reset input_2 and input_3 when input_1 is cleared
          disableAndResetField(categorySelect);
          disableAndResetField(brandSelect);
          lastSelectedCategory = '';
          lastSelectedBrand = '';
          resetCategories();
          resetBrands();
        }
      }

      function filterCategoriesByCondition(condition) {
        // Parse condition - could be single value like "new" or "used", or both like "new,used"
        const conditionsToMatch = condition.split(',');

        categorySelect.innerHTML = '';
        categoryOptions.forEach(function (opt) {
          const clonedOpt = opt.cloneNode(true);

          if (!opt.value) {
            // Always show placeholder
            categorySelect.appendChild(clonedOpt);
            return;
          }

          const catConditions = opt.getAttribute('data-used-conditions');
          if (!catConditions) {
            // If no conditions data, hide the option - don't show categories without condition data
            return;
          }

          // Check if category supports any of the selected conditions
          const catConditionsList = catConditions.split(',');
          const hasMatch = conditionsToMatch.some(cond => catConditionsList.includes(cond));

          if (hasMatch) {
            clonedOpt.hidden = false;
            categorySelect.appendChild(clonedOpt);
          }
        });

        // Try to restore previously selected category if it's still available
        if (lastSelectedCategory) {
          const compatibleCategory = Array.from(categorySelect.options).find(opt => opt.value === lastSelectedCategory);
          if (compatibleCategory) {
            categorySelect.value = lastSelectedCategory;
            // Also need to update brands based on this category
            filterBrandsByCategory();
          } else {
            // Category no longer available, reset downstream
            lastSelectedCategory = '';
            disableAndResetField(brandSelect);
            lastSelectedBrand = '';
          }
        }
      }

      function filterBrandsByCategory() {
        const selectedCat = categorySelect.value;
        lastSelectedCategory = selectedCat; // Store selected category

        if (!selectedCat) {
          // Reset and disable brands if no category selected
          disableAndResetField(brandSelect);
          lastSelectedBrand = '';
          resetBrands();
          return;
        }

        // Enable input_3 (brand) when input_2 (category) has a value
        enableNextField(brandSelect);

        const selectedCondition = conditionSelect.value;
        const conditionsToMatch = selectedCondition ? selectedCondition.split(',') : [];

        const catOption = categorySelect.querySelector('option[value="' + selectedCat + '"]');

        // Get the brands-by-condition mapping (format: "new:brand1,brand2|used:brand3,brand4")
        const brandsByConditionAttr = catOption && catOption.getAttribute('data-brands-by-condition');

        let allowedBrandsList = [];

        if (brandsByConditionAttr && conditionsToMatch.length > 0) {
          // Parse the data-brands-by-condition attribute
          const conditionMappings = brandsByConditionAttr.split('|');

          conditionMappings.forEach(function(mapping) {
            const parts = mapping.split(':');
            if (parts.length === 2) {
              const mappingCondition = parts[0];
              const mappingBrands = parts[1].split(',');

              // If this condition is one we're looking for, add its brands
              if (conditionsToMatch.includes(mappingCondition)) {
                allowedBrandsList = allowedBrandsList.concat(mappingBrands);
              }
            }
          });

          // Remove duplicates
          allowedBrandsList = Array.from(new Set(allowedBrandsList));
        }

        // Always show the placeholder
        brandSelect.innerHTML = '';
        brandOptions.forEach(function (opt) {
          if (!opt.value) {
            brandSelect.appendChild(opt.cloneNode(true));
            return;
          }

          // Check if brand is in the allowed list for this category+condition combo
          if (allowedBrandsList.includes(opt.value)) {
            const newOpt = opt.cloneNode(true);
            newOpt.hidden = false;
            brandSelect.appendChild(newOpt);
          }
        });

        // Try to restore previously selected brand if it's compatible with the category and condition
        if (lastSelectedBrand) {
          const compatibleBrand = Array.from(brandSelect.options).find(opt => opt.value === lastSelectedBrand);
          if (compatibleBrand) {
            brandSelect.value = lastSelectedBrand;
          } else {
            lastSelectedBrand = '';
          }
        }
      }

      function filterCategoriesByBrand() {
        const selectedBrand = brandSelect.value;
        lastSelectedBrand = selectedBrand; // Store selected brand

        if (!selectedBrand) {
          // Reset categories if no brand selected
          resetCategories();
          return;
        }

        // If a category is already selected, don't change it
        // This is the key change to maintain category when brand is selected
        if (lastSelectedCategory) {
          return;
        }

        const brandOption = brandSelect.querySelector('option[value="' + selectedBrand + '"]');
        const allowedCats = brandOption && brandOption.getAttribute('data-used-categories');

        categorySelect.innerHTML = '';
        categoryOptions.forEach(function (opt) {
          if (!opt.value) {
            categorySelect.appendChild(opt.cloneNode(true));
            return;
          }
          if (!allowedCats || allowedCats.split(',').includes(opt.value)) {
            const newOpt = opt.cloneNode(true);
            newOpt.hidden = false;
            categorySelect.appendChild(newOpt);
          }
        });
      }

      function resetBrands() {
        brandSelect.innerHTML = '';
        brandOptions.forEach(function(opt) {
          brandSelect.appendChild(opt.cloneNode(true));
        });
      }

      function resetCategories() {
        categorySelect.innerHTML = '';
        categoryOptions.forEach(function(opt) {
          categorySelect.appendChild(opt.cloneNode(true));
        });
      }

      conditionSelect.addEventListener('change', handleConditionChange);
      categorySelect.addEventListener('change', filterBrandsByCategory);
      brandSelect.addEventListener('change', filterCategoriesByBrand);
    })();
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js